import { Tooltip } from "react-tooltip";
import ClassLinkIcon from "../assets/ClassLinkIcon";
import CleverIcon from "../assets/CleverIcon";

interface IconProps {
	isClassLinkEntity?: boolean;
	isCleverEntity?: boolean;
	iconClasses?: string;
}

export function ClassLinkOrCleverIcon(props: IconProps) {
	if (props.isCleverEntity) {
		return (
			<CleverIcon
				className={`${props.iconClasses ?? "size-8"} p-1 rounded-md fill-white bg-[#1464FF]`}></CleverIcon>
		);
	}
	if (props.isClassLinkEntity) {
		return (
			<ClassLinkIcon
				className={`${props.iconClasses ?? "size-8"}  p-1 rounded-md fill-white bg-[#0a4d7f]`}></ClassLinkIcon>
		);
	}
	return;
}

interface IconWithTooltipProps extends IconProps {
	tooltipContent?: string;
	tooltipId: string;
}

export function ClassLinkOrCleverIconWithTooltip(props: IconWithTooltipProps) {
	return (
		<>
			<span data-tooltip-id={props.tooltipId}>
				<ClassLinkOrCleverIcon
					isClassLinkEntity={props.isClassLinkEntity}
					isCleverEntity={props.isCleverEntity}
					iconClasses={props.iconClasses}
				/>
			</span>
			<Tooltip
				id={props.tooltipId}
				place="top-start"
				content={props.tooltipContent ?? "This has an outside site account"}
			/>
		</>
	);
}
